module.exports = __webpack_public_path__ + "static/hero-d8300305491508e5d716b1dcabfc2634.svg";